import { Tag } from '@servicetitan/design-system';
import { tokens } from '@servicetitan/tokens/core';
import styled from 'styled-components';

export const StyledTag = styled(Tag)`
  border: 1px solid ${tokens.colorBlueGrey200};
`;
